import type { ReactNode } from "react";
import {
  CloudIcon,
  CommandIcon,
  FolderIcon,
  FolderPlusIcon,
  LinkIcon,
  MonitorIcon,
} from "lucide-react";
import { GithubIcon } from "~/components/icons/GithubIcon";

import { ITEM_ICON_CLASS, type AddProjectSourceIconName } from "./CommandPalette.logic";
import type { ProjectImportDestinationKind } from "../projectImportStore";

/**
 * The glyph for one add-project row — the source it comes from, or the
 * destination it lands in.
 *
 * `CommandPalette.logic` decides WHICH icon a source gets (`AddProjectSourceIconName`)
 * and deliberately names it rather than returning an element, so the decision
 * stays testable without React. This is the other half of that split: the one
 * place those names become elements. Two rows drawing the same name must draw
 * the same glyph at the same size, which a second `switch` somewhere else
 * cannot promise.
 */
export function renderAddProjectSourceIcon(
  iconName: AddProjectSourceIconName,
  className = ITEM_ICON_CLASS,
): ReactNode {
  switch (iconName) {
    case "folder":
      return <FolderIcon className={className} />;
    case "command":
      return <CommandIcon className={className} />;
    case "github":
      return <GithubIcon className={className} />;
    case "link":
      return <LinkIcon className={className} />;
    case "monitor":
      return <MonitorIcon className={className} />;
    case "folder-plus":
      return <FolderPlusIcon className={className} />;
  }
}

/** Cloud or this machine — the only two places an import can land. */
export function renderAddProjectDestinationIcon(
  destination: ProjectImportDestinationKind,
  className = ITEM_ICON_CLASS,
): ReactNode {
  return destination === "forge-cloud" ? (
    <CloudIcon className={className} />
  ) : (
    <MonitorIcon className={className} />
  );
}
